/**
 * Immediate phone consultation screen (BS-1158).
 *
 * Figma: https://www.figma.com/design/NBnn0MEdCHdbMj2LsWQqng/Consumer-App?node-id=21652-41317
 */
import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { preloadQuery } from "@relay";
import { createFileRoute } from "@tanstack/react-router";
import { usePreloadedQuery } from "react-relay";
import { graphql } from "relay-runtime";
import { PhoneConsultation } from "~/components/PersonalConsultation/PhoneConsultation";
import { AppHeader } from "~/components/layout/AppHeader";
import { PageContainer } from "~/components/layout/PageContainer";
import type { consultationPhoneQuery } from "./__generated__/consultationPhoneQuery.graphql";

export const query = graphql`
	query consultationPhoneQuery($hubName: String!) @relay_test_operation {
		hubMeta(by: { name: $hubName }) @required(action: THROW) {
			id
			hub @required(action: THROW) {
				id
			}
			organization {
				id
				pharmacyHubs(pagination: { page: 0, pageSize: 100 }) {
					nodes {
						id
						hubId
						...PhoneConsultationFragment
					}
				}
			}
		}
	}
`;

export const Route = createFileRoute("/$hubMetaName/consultation/phone")({
	beforeLoad: () => {
		document.title = "bacehub | Pharmaceutical Consulting";
	},
	component: RouteComponent,
	loader: (ctx) =>
		preloadQuery<consultationPhoneQuery>(ctx.context.relayEnvironment, query, {
			hubName: ctx.params.hubMetaName,
		}),
});

function RouteComponent() {
	const i18n = useI18nContext().LL["new-ui"];
	const { hubMeta } = usePreloadedQuery<consultationPhoneQuery>(query, Route.useLoaderData());

	const pharmacyHub = hubMeta.organization.pharmacyHubs.nodes.find((node) => node.hubId === hubMeta.hub.id);

	if (!pharmacyHub) {
		return (
			<PageContainer>
				<AppHeader service="ALL" />
				<div className="flex flex-col gap-1 px-6 py-2">
					<h1 className="font-breit text-2xl leading-8 text-neutral-900">
						<T>{i18n.CONSULTATION_PHONE_TITLE()}</T>
					</h1>
					<p className="text-sm leading-5 text-muted-foreground">
						<T>{i18n.CONSULTATION_NONE_OFFERED()}</T>
					</p>
				</div>
			</PageContainer>
		);
	}

	return <PhoneConsultation pharmacyHub={pharmacyHub} />;
}
